import { render, staticRenderFns } from "./SearchInfoHeaderComponent.vue?vue&type=template&id=43fa0bb9&scoped=true"
import script from "./SearchInfoHeaderComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchInfoHeaderComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchInfoHeaderComponent.vue?vue&type=style&index=0&id=43fa0bb9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fa0bb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43fa0bb9')) {
      api.createRecord('43fa0bb9', component.options)
    } else {
      api.reload('43fa0bb9', component.options)
    }
    module.hot.accept("./SearchInfoHeaderComponent.vue?vue&type=template&id=43fa0bb9&scoped=true", function () {
      api.rerender('43fa0bb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchInfoHeaderComponent.vue"
export default component.exports